import React from "react";
import { platforms } from "../mock";

const Platforms = () => {
  const track = [...platforms, ...platforms];
  return (
    <section className="py-20 bg-[#F5F7FB]">
      <div className="container-x text-center reveal">
        <span className="tag-chip">Tools & Platforms</span>
        <h2 className="section-title mt-4 max-w-3xl mx-auto">
          Platforms and tools we use for enterprise data engineering
        </h2>
        <p className="section-sub mt-4 max-w-2xl mx-auto">
          Secure, large-scale data infrastructure using leading cloud platforms, modern data warehouses, and enterprise orchestration tools.
        </p>
      </div>

      <div className="mt-12 overflow-hidden relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#F5F7FB] to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#F5F7FB] to-transparent z-10" />
        <div className="flex gap-6 marquee-track w-max">
          {track.map((p, i) => (
            <div key={i} className="shrink-0 w-56 h-28 rounded-2xl bg-white border border-slate-200 flex items-center justify-center gap-4 px-6 hover-lift">
              <div className="h-12 w-12 rounded-xl bg-[#0B1B3B] text-white font-bold flex items-center justify-center text-sm">
                {p.initials}
              </div>
              <div className="font-semibold text-[#0B1B3B]">{p.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Platforms;
